import { I as attr, U as store_get, Y as unsubscribe_stores } from "./index2.js";
import { t as theme } from "./stores.js";
function ThemeHiddenInput($$payload) {
  var $$store_subs;
  $$payload.out.push(`<input type="number" hidden name="theme"${attr("value", store_get($$store_subs ??= {}, "$theme", theme))}/>`);
  if ($$store_subs) unsubscribe_stores($$store_subs);
}
export {
  ThemeHiddenInput as T
};
